/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const navbarInit = () => {
  const body = document.getElementsByTagName('body')[0] as HTMLBodyElement;
  const html = document.getElementsByTagName('html')[0] as HTMLElement;
  const header: Element = document.querySelector('.header');
  const menu: Element = document.querySelector('.bottom-header__menu');
  const headerMenu: Element = header.querySelector('.header__menu');
  const toggler: Element = header.querySelector('.header-toggler');
  const headerActive: string = 'header--active';
  const togglerActive: string = 'toggler--active';
  const bodyHidden: string = 'overflow-hidden';

  menu.insertAdjacentHTML('beforebegin', '<form method="GET" class="header__mobile-search"><input type="search" name="s" placeholder="Zoeken..."></form>');

  // Add active class to current click
  // and stop propagation
  toggler.addEventListener('click', (e: Event) => {
    e.stopPropagation();
    header.classList.toggle(headerActive);
    toggler.classList.toggle(togglerActive);
    body.classList.toggle(bodyHidden);
    html.classList.toggle(bodyHidden);
  });

  // Stop propagation when clicking on
  // element with .header__menu class
  headerMenu.addEventListener('click', (e: Event) => {
    e.stopPropagation();
  });
};

export default navbarInit;
